export default __webpack_public_path__ + "static/media/contact.b53a1b40.jpg";